// extracted by mini-css-extract-plugin
module.exports = {"container":"swap_container__3qDCD","sidebar":"swap_sidebar__1KCth","rightsection":"swap_rightsection__2BLxZ"};